import { render, staticRenderFns } from "./fullscreen-content.component.vue?vue&type=template&id=9ac65f7a&"
import script from "./fullscreen-content.component.vue?vue&type=script&lang=ts&"
export * from "./fullscreen-content.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports